import React from "react";
import PropTypes from "prop-types";
import ToggleSwitchRevamp from "../../shared/toggle-switch-revamp";
import { trackCustomReMarketingEvents } from "../../../tracking";
import { MARKETING_EVENTS_CONSTANTS } from "../../../tracking/marketing-page-events";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";

const TradeInYourCarToggleButtonRevamp = ({
    tradeInToggleSelected,
    setTradeInToggleSelectedConnect,
    onTradeInSelectCallback = () => {},
    fetchCarDetailsConnect,
    updateLoginFetchCarDetailCompletedConnect,
    showCdpGalleryVariantData,
    carId
}) => {
    const showS20GalleryVariant = showCdpGalleryVariantData === EXPERIMENT_TYPE.VARIANT_B;
    const onTradeInSelectHandler = () => {
        setTradeInToggleSelectedConnect(!tradeInToggleSelected);
        onTradeInSelectCallback();
        fetchCarDetailsConnect(carId, {showS20GalleryVariant}).then(({detail}) => {
            trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.CAR_DETAIL, {ecomm_prodid: detail.appointmentId, ecomm_totalvalue: detail.egc });
        });
        updateLoginFetchCarDetailCompletedConnect(true);
    };
    return (
        <React.Fragment>
            <ToggleSwitchRevamp onChangeCallback={onTradeInSelectHandler} checked={tradeInToggleSelected}/>
        </React.Fragment>
    );
};

TradeInYourCarToggleButtonRevamp.propTypes = {
    tradeInToggleSelected: PropTypes.bool,
    setTradeInToggleSelectedConnect: PropTypes.func,
    onTradeInSelectCallback: PropTypes.func,
    fetchCarDetailsConnect: PropTypes.func,
    updateLoginFetchCarDetailCompletedConnect: PropTypes.func,
    showCdpGalleryVariantData: PropTypes.bool,
    carId: PropTypes.number
};

export default TradeInYourCarToggleButtonRevamp;
